import { createSelector } from 'reselect';

export const getState = (state) => state.subscriptions;

export const getSubscription = createSelector(getState, ({ subscription }) => subscription);

export const getPricing = createSelector(getState, ({ pricing }) => pricing);
